<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-9 customHeading">
          <h3>{{moduleName}}</h3>
        </div>
       
        <!--==========Class dropdown============-->
     

        <!---SEARCH BOX-->
         <div class="col-md-2">
          <div class="searchbox input-group" role="group">
          <input class="form-control search-box my-search-box" type="text" placeholder="Name" aria-label="search" v-model="filteredText">
         
          <button class="search-button btn btn-primary filter"  @click="getContractors()"><i class="fa fa-search search-icon"></i></button>
          </div>
          
        </div>
        <div class="col-md-1 Add-button" style="text-align:center">
          <a href="javascript:void(0)">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn" v-b-modal.AddContractorModal>Add </div>
            </div>
          </a>
        </div> 

       </div>
       <div class="row">
         <div class="col">
          <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
         </div>
        </div>
      <div>
        <div class="row"><div class="col">
        <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
          style="font-size: 85%;">
            <thead>
              <tr>
             
                <th role="columnheader">Name</th>
                 <th role="columnheader">Phone</th>
                 <th role="columnheader">Address</th>
                  <th role="columnheader">Status</th>
                <th role="columnheader" >Actions</th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if= "contractors==null" >
                <td class = "center-td" colspan="5">No Data</td>
              </tr>
              
            <tr v-else v-for="record in contractors" :key=record.id>
              <td  role="cell">{{record.name}}</td>
              
              <td  role="cell">{{record.phoneNumber}} </td>
              <td  role="cell">{{record.address}} </td>
              <td  role="cell">{{record.isActive?"Active":"InActive"}} </td>
              <td>
               <span @click= "passRecordToEdit(record)">
                  <i role="button" style="color:green" class="far fa-edit"></i>&nbsp;|&nbsp;
                </span>
                <span @click= "passRecordToDelete(record.id)">
                  <i role="button" style="color:green" class="far fa-trash-alt"></i>
                </span>
             
              </td>
            </tr>
          </tbody>
        </table>
      </div></div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getContractors()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
    <AddContractorModal/>
    <EditContractorModal :contractorToEdit= "recordToEdit" v-if="recordToEdit != null"/>
    <DeleteModal :msgForModal= "msgForModal" :apiEndPoint = "apiEndPoint" :heading = "deleteModalHeading"  :entityId = "recordToDelete"/>
   
   
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import AddContractorModal from './modals/AddContractorModal'
import DeleteModal from '../../modals/DeleteModal'
import EditContractorModal from './modals/EditContractorModal'

export default {
    name: 'Contractor',
    data(){
        return{
          moduleName:'Contractor',
     
      
          isLoading:false,
          recordToEdit :  null,
          recordToDelete:null,
          msgForModal:null,
          apiEndPoint:null,
          deleteModalHeading:null,
      
          contractors:null,
        
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25     
		}
  },
 
methods:{


    getPage(page)
  {
    this.page = page;
    this.getContractors();
  },

   passRecordToEdit(comp)
  {
    this.recordToEdit = comp;
    setTimeout(
      () => {
    this.$bvModal.show('EditContractorModal');
  },100)
  },
  passRecordToDelete(id)
  {
    this.recordToDelete = id;
    this.msgForModal = "Confirm to delete !";
    this.apiEndPoint = "contractor/Delete/";
    this.deleteModalHeading = "Delete"
    this.$bvModal.show('DeleteModal')

  },
 
    
   

    getContractors(){
       this.isLoading = true;
      axios.post('/contractor/getall',{"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText})
    .then(res=>{
      this. isLoading = false;

      if(res.data.status == 1)
      {
       
        this.contractors=res.data.data;
    
        this.rows = res.data.totalRecords;
      }
      else if(res.data.status== -1)
      {
          this.$bvModal.msgBoxOk(res.data.msg, {
          title: 'Error!',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          headerClass: 'p-10 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
          });
      }
      else {
        this.contractors = null;
      
      }
    });
    },
		
   

  search(){
   
    this.page=this.pageNumOnSearch;
    this.getContractors();
  }
  },
	created(){
    this.getContractors();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    AddContractorModal,
    DeleteModal,
    EditContractorModal
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}

</style>